import type { ComponentType } from "react";
import {
  LayoutDashboard,
  Power,
  ToggleLeft,
  Rows3,
  BookOpenText,
  Bell,
  Tag,
  History,
  ShieldCheck,
  type LucideProps,
} from "lucide-react";

export interface NavItem {
  to: string;
  label: string;
  icon: ComponentType<LucideProps>;
  end?: boolean;
}

export const NAV_ITEMS: NavItem[] = [
  { to: "/", label: "Dashboard", icon: LayoutDashboard, end: true },
  { to: "/app-status", label: "Estado de la app", icon: Power },
  { to: "/features", label: "Funciones", icon: ToggleLeft },
  { to: "/home-blocks", label: "Inicio", icon: Rows3 },
  { to: "/daily-content", label: "Contenido diario", icon: BookOpenText },
  { to: "/notifications", label: "Notificaciones", icon: Bell },
  { to: "/versions", label: "Versiones", icon: Tag },
  { to: "/audit", label: "Auditoria", icon: History },
  { to: "/security", label: "Seguridad", icon: ShieldCheck },
];
